import { useMemo } from "react";
import markdownIT from 'markdown-it';

export const useMarkdownIt = () => useMemo(() =>  {
    const markdownITInstance = markdownIT({html: true, xhtmlOut: true, linkify: true, breaks: true,
    typographer: true});

    const defaultRender = markdownITInstance.renderer.rules.link_open || ((tokens, idx, options, env, self) => {
        return self.renderToken(tokens, idx, options);
    });

    markdownITInstance.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        // If you are sure other plugins can't add `target` - drop check below
        const targetIndex = tokens[idx].attrIndex('target');
    
        if (targetIndex < 0) {
            tokens[idx].attrPush(['target', '_blank']); // add new attribute
        } else {
            tokens[idx].attrs[targetIndex][1] = '_blank';    // replace value of existing attr
        }
    
        // pass token to default renderer.
        return defaultRender(tokens, idx, options, env, self);
    };

    return markdownITInstance;
}
, []);